<script>
import { BModal } from 'bootstrap-vue'

export default {
    components: {BModal},
    props: {
        title: {
            type: String,
            default: 'Select property values',
        }
    },
    methods: {
        show() {
            this.$refs['selector'].show();
        },
        close() {
            this.$refs['selector'].hide();
        },
        closeAndEmit() {
            this.$emit('save');
        }
    }
}
</script>

<template>
    <b-modal
        ref="selector"
        cancel-variant="outline-secondary"
        size="xl"
        centered
        no-close-on-backdrop
        :title="title"
        @ok="closeAndEmit"
        @hide="$emit('modalHide')"
    >
        <slot>Empty block</slot>
    </b-modal>
</template>
